import HeroContent from "./HeroContent";
import HeroLeft from "./HeroLeft";
import HeroRight from "./HeroRight";
import HeroText from "./HeroText";
import HeroTitle from "./HeroTitle";
import HeroWrapper from "./HeroWrapper";

export { HeroContent, HeroLeft, HeroRight, HeroText, HeroTitle, HeroWrapper };
